import { useState, useEffect } from "react";
import axiosInstance from "../../utils/axios";

const useDropdownFetch = (url) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(url);
        if (response.data.Status === "Success") {
          const fetchedData = response.data.Data;
          const newOptions = [
            { value: "", label: `Select` },
            ...Object.keys(fetchedData).map((key) => ({
              value: key,
              label: fetchedData[key],
            })),
          ];
          setOptions(newOptions);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { options, loading, error };
};

export default useDropdownFetch;
